<app-view-title [mode]="late ? 'danger' : 'safe'" Title="{{ 'Intellitrailer.Rental.InFlight.Headline' | translate : 'Active rent' }}"></app-view-title>
<view-content [centered]="true">
  @if(booking) {
  <app-card>
    <app-rental-box [booking]="booking" [hasLock]="hasLock" [allowUnmanned]="allowUnmanned" [isNuwiel]="isNuwiel" [isPickup]="false" (rentalAction)="recieveRentalAction($event)" (toFarAwayChange)="onToFarAwayChanged($event)"></app-rental-box>
  </app-card>
  }
</view-content>
@if (allowUnmanned) {
  <view-actions>
    <button type="button" mat-raised-button (click)="sendRentalAction('return')">{{ 'Intellitrailer.Rental.InFlight.TerminateRent' | translate : 'Terminate rent' }}</button>
  </view-actions>
 }

